exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-aceb2dba]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.booking-box[data-v-aceb2dba]{background-color:#fff;padding:1.4rem 16px;border-radius:15px;border:1px solid #9b9b9b;margin-bottom:20px}@media (min-width:640px){.booking-box[data-v-aceb2dba]{padding:1.4rem 2.2rem}}", ""]);

// exports
